import axios from 'axios';
import { API_BASE_URL } from '../config'; 

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor is perfect as is.
api.interceptors.request.use(
  (config) => {
      const token = localStorage.getItem('token');
      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
  },
  (error) => {
      return Promise.reject(error);
  }
);


// --- THIS IS THE IMPROVED RESPONSE INTERCEPTOR ---
api.interceptors.response.use(
  (response) => {
    // On success, just return the data payload
    return response.data;
  },
  (error) => {
    // --- THIS IS THE NEW, CRUCIAL LOGIC ---
    // Check if the error is a 401 Unauthorized response
    if (error.response && error.response.status === 401) {
        
        // This means the user's token is invalid or expired.
        // We should log them out and redirect to the login page.
        
        console.error("Authentication Error: Token is invalid or expired. Logging out.");
        
        // 1. Remove the bad token from storage
        localStorage.removeItem('token');
        
        // 2. Remove the default Authorization header to prevent sending the bad token again
        delete api.defaults.headers.common['Authorization'];

        // 3. Redirect to the login page.
        // This is a hard redirect which will clear all application state.
        // This is generally the safest action after a critical auth error.
        window.location.href = '/login'; 
    }
    
    // For all other errors, just pass them along.
    // Your component's .catch() block can still handle them.
    return Promise.reject(error);
  }
);

export default api;